import React, { useEffect, useRef, useState } from 'react'
import { DropDownList } from '@progress/kendo-react-dropdowns';
import MyStatusCell from '../../../components/MyStatusCell';
import { Loader } from '../../../framework/forms/helpercomponents/Loader';
import { useTranslation } from '../../../locale/useTranslation';
import { getter, process } from '@progress/kendo-data-query';
import ManageNodeTreeViewEditPanel from './ManageNodeTreeViewEditPanel';
import * as API from '../../../framework/API/api';
import { COLUMNSTYPE, ENTITYNAME, FILEURL, LOCALSTORAGE_KEY, MAM_STATUS, MEDIACATEGORIES, PUBLISH_REPORT, TOAST_TYPES, TRANSMISSION_ACTION, TRANSMISSION_ACTIVE_STATUS, TRANSMISSION_STATUS } from '../../../framework/constant/constant';
import { getSelectedState, Grid, GridColumn } from '@progress/kendo-react-grid';
import { DateCell, DateOnlyCell, LocalDateTimeColumn } from '../../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import { ArrayCell } from '../../../framework/forms/helpercomponents/CustomGridCells/ArrayCell';
import { utility } from '../../../framework/utility/utilityProvider';
import { TimeCell } from '../../../framework/forms/helpercomponents/CustomGridCells/TimeCell';
import MediaEpisodeHistory from '../../Planning/MediaEpisodeHistory';
import RoundButton from '../../../framework/forms/helpercomponents/buttons/RoundButton';
import { MenuCommandCell } from '../../../framework/forms/helpercomponents/CustomGridCells/MenuCommandCell ';
import { collectionMenuModelTransmission } from '../../../framework/forms/helpercomponents/contextMenu/menus/collectionMenuModel';
import { UserPreference } from '../../userPreference/UserPreference';
import ContractCollectionSelection from '../../Contract/ContractCollectionSelection';
import CreateTransmissionForm from '../../../framework/OTT/CreateTransmissionForm';
import MAMStatusCell from '../../../components/MAMStatusCell';
import { useLocation, useNavigate } from 'react-router-dom';
import RefreshButton from '../../../framework/forms/helpercomponents/buttons/RefreshButton';
import BossDialog from '../../../components/BossDialog';
import CollectionSelection from '../../../framework/forms/CollectionSelection';
import { ConfirmDeleteAlert } from '../../../ConfirmAlert';
import EditTransmissonForm from './EditTransmissonForm';
import { ContextMenu } from 'primereact/contextmenu';
import { TransmissionTypeStatusCell } from '../../../components/TransmissionTypeStatusCell';
import NodeTreeViewForm from './NodeTreeViewForm';
import CreateTransmissionOfferForm from '../vodOffer/createTransmissionOfferForm';
import { AssetOfferLinkBrowserCollection } from './AssetOfferLinkBrowserCollection';
import SaveButton from '../../../framework/forms/helpercomponents/buttons/SaveButton';
import ToastNotification from '../../../components/ToastNotification';
import * as XLSX from 'xlsx';
import moment from 'moment';

const SELECTED_FIELD = "selected";
const DATA_ITEM_KEY = "_id";
const idGetter = getter(DATA_ITEM_KEY);

export const TransmissionBrowser = (props) => {

    const { selectedNode, query, showToggle = false, mainStyle = {}, gridStyle = {}, isFromMedia = false, handleCount, barStyle = {}, isFromMain = false, divstyle = {}, entityName, page_take = 50 } = props;

    const lang = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const menuRef = useRef(null);

    const searchParams = new URLSearchParams(location.search);
    const activeStatusParams = Number(searchParams.get("activeStatus")) || null;
    const [mediaData, setMediaData] = useState([]);
    const [filterdMediaData, setFilterdMediaData] = useState([]);
    const [sort, setSort] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const defaultNode = { _id: null, Name: "All" };
    const NotLinked = { _id: 0, Name: "Not Linked" };
    const defaultMamStatus = { _id: null, Description: "All" };
    const defaultActiveStatus = { _id: null, Description: "All" };
    const [isLinear, setIsLinear] = useState(false);
    const defaultFilters = {
        mamStatus: defaultMamStatus,
        node: defaultNode,
        activeStatus: activeStatusParams ? { _id: activeStatusParams, Description: utility.getKeyByValue(TRANSMISSION_STATUS, activeStatusParams) } : defaultActiveStatus,
        fromDate: "",
        toDate: "",
        notLinked: false,
        isCatchup: false
    };
    const [filters, _setFilters] = useState((isFromMedia || isFromMain) ? (utility.getValue(LOCALSTORAGE_KEY.transmissionBrowserFilters) ?? defaultFilters) : defaultFilters);
    const setFilters = (data) => {
        _setFilters(data);
        utility.setValue(LOCALSTORAGE_KEY.transmissionBrowserFilters, data);
    }
    const [nodes, setNodes] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [showPreferences, setShowPreferences] = useState(false);
    const [dataColumns, setDataColumns] = useState([]);
    const [showAttachOffers, setShowAttachOffers] = useState(false);
    const [selectedState, setSelectedState] = useState({});
    const [showMetaDataForm, setShowMetaDataForm] = useState({ show: false, item: {} });

    //----------FOR CREATE TRANSMISSION
    const [showMediaSelectionOfferCollection, setShowMediaSelectionOfferCollection] = useState(false);
    const [showTransmissonForm, setShowTransmissonForm] = useState(false);
    const [showOffersForm, setShowOffersForm] = useState({ show: false, item: {} });
    const [showEditTransmissonForm, setShowEditTransmissonForm] = useState({ show: false, data: [], isActionEdit: false });
    const [page, _setPage] = useState({ skip: 0, take: page_take, });
    const pageRef = useRef({ skip: 0, take: page_take });
    const setPage = (data) => {
        pageRef.current = data;
        _setPage(data);
    }
    const [total, setTotal] = useState(0);
    const [showNodePopup, setShowNodePopup] = useState(false);
    const [showCreateOfferForm, setShowCreateOfferForm] = useState(false);
    const [publishVodCatalogueMessage, setPublishVodCatalogueMessage] = useState("");
    const [isShowAllNodes, setIsShowAllNodes] = useState(false);

    const tempSelectedMediasRef = useRef();
    const [tempSelectedMedias, _setTempSelectedMedias] = useState([]);
    const setTempSelectedMedias = (data) => {
        _setTempSelectedMedias(data);
        tempSelectedMediasRef.current = data;
    }

    const [dropdownFilters, setDropdownFilters] = useState({});

    const selectedMediasRef = useRef();
    const [selectedMedias, _setSelectedMedias] = useState([]);
    const setSelectedMedias = (data) => {
        _setSelectedMedias(data);
        selectedMediasRef.current = data;
    }

    useEffect(() => {
        loadCombo();
    }, []);

    useEffect(() => {
        loadData({
            page: 1,
            per_page: page_take,
            query: query ?? [],
            mamStatus: filters.mamStatus,
            activeStatus: filters.activeStatus,
            searchText,
            fromDate: new Date(filters.fromDate).getTime(),
            toDate: new Date(new Date(filters.toDate).setUTCHours(23, 59, 59, 999)).getTime(),
            notLinked: filters.notLinked,
            isCatchup: filters.isCatchup,
            parentNode: filters.node
        });
    }, [query]);

    const loadCombo = async () => {

        if (isFromMedia || isFromMain) {
            let nodesRes = await API.getDataLookup(ENTITYNAME.Nodes, { query: ["Archive", "!=", true] });
            setNodes([defaultNode, ...nodesRes.data.sort((a, b) => a.Name.localeCompare(b.Name))]);
        }

    }


    const loadData = async (payload = {}) => {
        !payload.isSilentRefresh && setIsLoading(true);

        let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
        let columns = await API.getFormData(ENTITYNAME.Transmissions, currentUserId);

        if (columns.length > 0) {
            setDataColumns(columns);
        }

        const transmissionDataRes = await API.getTransmissions(payload);
        console.log(transmissionDataRes);

        if (transmissionDataRes.success) {
            let data = transmissionDataRes.data;
            setMediaData(data);
            setFilterdMediaData(data);
            setTotal(transmissionDataRes?.pagination?.total);
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: transmissionDataRes.message });
            setMediaData([]);
            setFilterdMediaData([]);
            setTotal(0);
        }
        setIsLoading(false);
    }

    const applyFilters = async (text, filter, loadFirstPage = false, isSilentRefresh = false) => {
        if (loadFirstPage) setPage({ skip: 0, take: page_take });

        let { mamStatus, activeStatus = {}, node = {}, fromDate = null, toDate = null, notLinked, isCatchup } = filter;

        let filterQ = [];

        if (query && query?.length > 0) {
            filterQ.push(query);
        }

        if (fromDate && toDate) {
            fromDate = new Date(fromDate).getTime();
            toDate = new Date(new Date(toDate).setUTCHours(23, 59, 59, 999)).getTime();
        } else {
            fromDate = null;
            toDate = null;
        }

        loadData({
            page: pageRef.current.skip / pageRef.current.take + 1,
            per_page: pageRef.current.take,
            query: filterQ,
            mamStatus,
            searchText: text,
            activeStatus,
            parentNode: node,
            fromDate,
            toDate,
            notLinked,
            isCatchup,
            isSilentRefresh
        });
    };

    const onChange = (e) => {
        const { name, value } = e.target;

        let tmpFilter = { ...filters, [name]: (name === "notLinked" || name === "isCatchup") ? !filters[name] : value }
        setFilters(tmpFilter);

        setSelectedItems([]);
        setSort([]);
        // applyFilters(searchText, tmpFilter);
        if (name === "activeStatus") {
            const params = new URLSearchParams(location.search);
            params.delete("activeStatus");

            navigate(
                {
                    pathname: location.pathname,
                    search: params.toString()
                },
                { replace: true }
            );
        }
    };

    const onSearch = (e) => {
        e.preventDefault();
        let text = e.target.value?.trim().toLowerCase();
        setSearchText(text);
    };

    // Search 
    useEffect(() => {
        if (searchText == null) return;
        if (searchText != "") {
            const timeOut = setTimeout(() => {
                setIsLoading(true);
                applyFilters(searchText, filters, true);
            }, 1000);
            return () => clearTimeout(timeOut);
        } else {
            setIsLoading(true);
            applyFilters(searchText, filters, true);
        }
    }, [searchText]);

    const onDateFilterChange = (e) => {
        const { name, value } = e.target;
        const tmpFilter = { ...filters, [name]: value };

        if (name === "fromDate" && tmpFilter.toDate && value && value > tmpFilter.toDate) {
            tmpFilter.toDate = value;
        }

        if (name === "toDate" && tmpFilter.fromDate && value && value < tmpFilter.fromDate) {
            tmpFilter.fromDate = value;
        }

        setFilters(tmpFilter);
        setSelectedItems([]);
        setSort([]);
        // applyFilters(searchText, tmpFilter);
    };

    const onCloseUserPrefence = async () => {
        setShowPreferences(!showPreferences);
        await loadData({
            page: page.skip / page.take + 1,
            per_page: page.take,
            query: query ?? [],
            mamStatus: filters.mamStatus._id,
            activeStatus: filters.activeStatus._id,
            searchText: searchText,
            fromDate: new Date(filters.fromDate).getTime(),
            toDate: new Date(new Date(filters.toDate).setUTCHours(23, 59, 59, 999)).getTime(),
        });
    }

    const handleSingleSelectUpdatedData = (data = {}) => {

        if (!data || Object.keys(data).length === 0) return setSelectedItems([]);

        const updateList = (list) => list.map((item) => item?._id === data._id ? data : item);

        setMediaData(updateList(mediaData));
        setFilterdMediaData(updateList(filterdMediaData));
    };

    const exportTranscodingDublist = async () => {

        const res = await API.exportTranscodingDublist(query);
        if (res.success) {
            window.open(FILEURL().BASEURL + 'downloadReport/' + res.fileName)
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const onExportGridData = () => {
        if (!filterdMediaData || filterdMediaData.length === 0) {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: "No data to export" });
            return;
        }

        const columnsToUse = dataColumns.length > 0
            ? dataColumns
            : Object.keys(filterdMediaData[0] || {}).map(key => ({ name: key, label: key }));

        const exportData = filterdMediaData.map(item => {
            const row = {};
            columnsToUse.forEach(col => {
                if (col.type === COLUMNSTYPE.hidden) return;

                let value = utility.getNestedValue(item, col.name);

                if (col.type === COLUMNSTYPE.date) {
                    value = value ? moment(value).utc().format(col.format ?? 'DD-MM-YYYY') : '';
                }
                else if (col.type === COLUMNSTYPE.datetime) {
                    value = value ? utility.convertMilisecondsToDateTimeString(value) : '';
                }
                else if (col.type === COLUMNSTYPE.localdatetime) {
                    value = value ? moment(value).format(col.format ?? 'YYYY-MM-DD HH:mm:ss') : '';
                } else if ((col.name && typeof col.name === 'string' && col.name.includes("Duration")) || col.type === COLUMNSTYPE.time) {
                    value = value ? utility.convertMilisecondsToStringWithFrames(value) : '';
                } else if (col.type === COLUMNSTYPE.mamStatus) {
                    value = item?.Mam?.Status ? utility.getKeyByValue(MAM_STATUS, item.Mam.Status) : '';
                } else if (col.name === "status") {
                    value = item?.status ? utility.getKeyByValue(TRANSMISSION_ACTIVE_STATUS, item.status) : '';
                } else if (col.name === "action") {
                    value = item?.action ? utility.getKeyByValue(TRANSMISSION_ACTION, item.action) : '';
                } else if (col.name === "IsThumbnailProcessed") {
                    value = item?.IsThumbnailProcessed ? "Processed" : "Pending";
                } else if (col.type === COLUMNSTYPE.array) {
                    const format = col.format ?? "Description";
                    if (Array.isArray(value)) {
                        value = value.map(x => x[format] || x.Name || x.Description || JSON.stringify(x)).join(', ');
                    } else if (value && typeof value === 'object') {
                        value = value[format] || value.Name || value.Description || JSON.stringify(value);
                    }
                } else if (col.type === COLUMNSTYPE.transmissionTypeStatus) {
                    if (value && typeof value === 'object') {
                        value = value.Description || value.Name || JSON.stringify(value);
                    }
                } else if (col.type === COLUMNSTYPE.offerCount) {
                    value = item?.offerCount ?? '';
                }

                if (typeof value === 'object' && value !== null) {
                    if (Array.isArray(value)) {
                        value = value.map(x => x.Name || x.Description || JSON.stringify(x)).join(', ');
                    } else {
                        value = value.Name || value.Description || JSON.stringify(value);
                    }
                }

                row[col.label || col.name] = value ?? '';
            });
            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Transmissions");
        XLSX.writeFile(workbook, "Transmissions.xlsx");
    };

    const onEditMetaData = (dataItem) => {
        setShowMetaDataForm({ show: true, item: dataItem });
    }

    const onUpdateNode = (dataItem) => {
        setSelectedItems([dataItem]);
        setShowNodePopup(true);
    }

    const onUnPublishOffer = async (data) => {

        let tableName = data.series_assetofferlink_id
            ? ENTITYNAME.Series
            : data.season_assetofferlink_id
                ? ENTITYNAME.Season
                : ENTITYNAME.MediaEpisode;

        let assetofferlink_id = data.assetofferlink_id;

        let res = await API.unPublishOfferAndRemoveTransmission({ assetOfferLinkId: assetofferlink_id, tableName: tableName });
        if (res.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }

    }

    const onShowOffers = (dataItem = {}) => {
        setShowOffersForm({ show: true, item: dataItem });
    }

    const onDeleteTransmission = (dataItem = {}) => {
        ConfirmDeleteAlert(() => handleDeleteSelectedItems([dataItem]), () => { })
    }

    const onEditTransmission = (dataItem = {}) => {
        setShowEditTransmissonForm({ show: true, data: [dataItem] });
    }

    const onEditTransmissonAction = (dataItem = {}) => {
        setShowEditTransmissonForm({ show: true, data: [dataItem], isActionEdit: true });
    }

    const openNodeBrowser = (dataItem = {}) => {
        console.log(dataItem);
        const nodeId = dataItem?.nodes?.length > 0 ? dataItem?.nodes[0]?._id : dataItem?.parentNode?._id ?? "";
        window.open(`/home/nodeBrowser?nodeId=${nodeId}`, '_blank');
    }

    const onAddOffer = (dataItem = {}) => {
        console.log(dataItem);
        setSelectedItems([dataItem]);
        setShowCreateOfferForm(true);
    }

    const resetThumbnailStatus = async (dataItems = []) => {

        const items = Array.isArray(dataItems) ? dataItems : [dataItems];

        let res = await API.saveData(ENTITYNAME.Transmissions, items.map(item => ({ _id: item._id, IsThumbnailProcessed: false })));

        if (res.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.thumbnail_status_reset_success_message });
            const updatedIds = items.map(x => x._id)
            setMediaData(mediaData.map(x => updatedIds.includes(x._id) ? { ...x, IsThumbnailProcessed: false } : x))
            setFilterdMediaData(filterdMediaData.map(x => updatedIds.includes(x._id) ? { ...x, IsThumbnailProcessed: false } : x))
            setSelectedItems([]);
            setSelectedState({})
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const MyCommandCell = (props) => (
        <MenuCommandCell
            {...props}
            onEdit={onEditTransmission}
            onEditAction={onEditTransmissonAction}
            onDelete={onDeleteTransmission}
            updateNode={onUpdateNode}
            openNodeBrowser={openNodeBrowser}
            showOffers={onShowOffers}
            showMedia={showMedia}
            unPublishOffer={onUnPublishOffer}
            myMenuModel={collectionMenuModelTransmission}
            onAddOffer={onAddOffer}
            resetThumbnailStatus={resetThumbnailStatus}
        />
    );

    const handleOfferMedia = (data) => {

        //HANDLE DUPCLICATE AND REMOVE
        let newData = [...data];
        if (selectedMedias.length > 0) {
            newData = utility.checkDuplicateInData(data, selectedMedias, "Title");
        }
        setTempSelectedMedias(newData);
        setSelectedMedias([...selectedMedias, ...newData]);
        setShowTransmissonForm(true);

    }

    const publishTransmission = async (transmissionData = []) => {

        let transmissionRes = await API.createTransmission(transmissionData);

        if (transmissionRes.success) {
            utility.deleteLocalStorageItem(ENTITYNAME.Nodes);
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: transmissionRes.message });
            loadData({ page: page.skip / page.take + 1, per_page: page.take, query: query ?? [], mamStatus: filters.mamStatus, activeStatus: filters.activeStatus, searchText });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: transmissionRes.message });
        }

    }

    const updateOfferGridData = async (dataList) => {

        //VALIDATION FOR MEDIA
        if (selectedMediasRef.current.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_media_error_message });
            return;
        }

        //NEW PAYLOAD
        let payload = {
            mediaEpisodes: tempSelectedMedias.map((x) => { return { _id: x._id.toString(), MediaCategory: x.MediaCategory } }),
            catalogue: {
                Catalogue: { _id: dataList.Catalogue._id, Description: dataList.Catalogue?.Description },
                ParentNodes: dataList.ParentNodes,
                Nodes: dataList.Nodes,
                Ott_Platforms: dataList.Ott_Platforms,
                TransmissionType: dataList.TransmissionType
            },
            entityName: entityName,
        }

        if (props.isFromContract) payload.contract = selectedNode;

        await publishTransmission(payload);

        setShowTransmissonForm(false);
        setSelectedMedias([]);
    }

    const onCreateTransmission = () => {
        if (isFromMedia) {
            handleOfferMedia([props.selectedNode]);
            return;
        }
        setShowMediaSelectionOfferCollection(true);
    }

    const refreshTransmissionBrowser = (loadFirstPage = false, isSilentRefresh = false) => {
        setSelectedItems([]);
        setSelectedState({});
        applyFilters(searchText, filters, loadFirstPage, isSilentRefresh);
    }

    const showOffersCell = (props) => {
        return (
            <td>
                <div style={{ color: 'blue', cursor: 'pointer' }}
                    onClick={() => {
                        onShowOffers(props.dataItem);
                    }}
                >
                    {props.dataItem.offerCount}
                </div>
            </td>
        )
    }

    const onCloseCreateTransmissionForm = () => {
        if (isFromMedia) setSelectedMedias([]);
        setShowTransmissonForm(false);
    }

    const handleAttachOffers = async (offerData = []) => {

        let offerPayload = {
            offers: offerData,
            transmissions: selectedItems,
        }

        let offerRes = await API.createOrUpdateMediaOffers(offerPayload);

        if (offerRes.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: offerRes.message });
            refreshTransmissionBrowser();
            return;
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: offerRes.message });
            return;
        }

    }

    const onHeaderSelectionChange = (event) => {
        const checked = event.syntheticEvent.target.checked;
        const newSelectedState = {};

        // For header selection, use all data items (filterdMediaData)
        filterdMediaData.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
        });

        setSelectedState(newSelectedState);

        // Sync to selectedItems for app logic
        if (checked) {
            setSelectedItems([...filterdMediaData]);
        } else {
            setSelectedItems([]);
        }

        // Update data rows' selected field for visual checkboxes
        const updatedData = filterdMediaData.map((item) => ({
            ...item,
            [SELECTED_FIELD]: checked
        }));
        setMediaData(updatedData);  // Original data
        setFilterdMediaData(updatedData);  // Filtered data
    };

    const onSelectionChange = (event) => {
        const newSelectedState = getSelectedState({ event, selectedState: selectedState, dataItemKey: DATA_ITEM_KEY });
        setSelectedState(newSelectedState);
        const selectedIds = Object.keys(newSelectedState).filter(id => newSelectedState[id]);
        const newSelectedItems = filterdMediaData.filter(item => selectedIds.includes(idGetter(item)));
        setSelectedItems(newSelectedItems);

        // Visual sync
        const updatedData = filterdMediaData.map(item => ({
            ...item,
            [SELECTED_FIELD]: !!newSelectedState[idGetter(item)]
        }));
        setFilterdMediaData(updatedData);
        setMediaData(updatedData);
    };

    const handleDeleteSelectedItems = async (data = []) => {

        let res = await API.updateTransmission({ query: ['_id', 'in', data?.map(x => x?._id)], data: { action: TRANSMISSION_ACTION.Delete } });
        console.log(res);

        if (res.success) {
            setSelectedState({});
            setSelectedItems([]);
            // refreshTransmissionBrowser();
            let deleteIds = data?.map(x => x?._id) ?? [];
            setMediaData(mediaData.map(x => deleteIds.includes(x?._id) ? { ...x, action: TRANSMISSION_ACTION.Delete } : x));
            setFilterdMediaData(filterdMediaData.map(x => deleteIds.includes(x?._id) ? { ...x, action: TRANSMISSION_ACTION.Delete } : x));
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.deleted_success_message });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    };

    const actionStatusCell = (props) => {
        const { dataItem } = props;

        let title = utility.getKeyByValue(TRANSMISSION_ACTION, dataItem?.action);
        let tileBackColor = "";
        let titleColor = "white";

        switch (dataItem?.action) {
            case TRANSMISSION_ACTION.Published:
                title = title;
                tileBackColor = "#63AA43";
                break;
            case TRANSMISSION_ACTION.Delete:
                title = title;
                tileBackColor = "#E72929";
                break;
            case TRANSMISSION_ACTION.Create:
                title = title;
                tileBackColor = "#3B82F6";
                break;
            case TRANSMISSION_ACTION.Update:
                title = title;
                tileBackColor = "#F8A506";
                titleColor = "black";
                break;
        }

        return (
            <MyStatusCell {...props} title={title} tileBackColor={tileBackColor} titleColor={titleColor} />
        );
    };

    const transmissionStatusCell = (props) => {
        const { dataItem } = props;

        let title = utility.getKeyByValue(TRANSMISSION_ACTIVE_STATUS, dataItem?.status);
        let tileBackColor = "";
        let titleColor = "white";

        switch (dataItem?.status) {
            case TRANSMISSION_ACTIVE_STATUS.Active:
                title = title;
                tileBackColor = "#63AA43";
                break;
            case TRANSMISSION_ACTIVE_STATUS.InActive:
                title = title;
                tileBackColor = "#E72929";
                break;
            case TRANSMISSION_ACTIVE_STATUS.Upcoming:
                title = title;
                tileBackColor = "#F8A506";
                titleColor = "black";
                break;
        }

        return (
            <MyStatusCell {...props} title={title} tileBackColor={tileBackColor} titleColor={titleColor} />
        );
    };

    const thumbnailStatusCell = (props) => {
        const { dataItem } = props;

        let title = dataItem?.IsThumbnailProcessed ? "Processed" : "Pending";
        let tileBackColor = dataItem?.IsThumbnailProcessed ? "#63AA43" : "#E72929";
        let titleColor = "white";

        return (
            <MyStatusCell
                {...props}
                title={title}
                tileBackColor={tileBackColor}
                titleColor={titleColor}
            />
        );
    };

    const pageChange = async (e) => {
        setPage(e.page);
        await applyFilters(searchText, filters)
        // const payload = {
        //     page: e.page.skip / e.page.take + 1,
        //     per_page: e.page.take,
        //     query: query ?? [],
        //     mamStatus: filters.mamStatus,
        //     activeStatus: filters.activeStatus,
        //     searchText,
        //     fromDate: filters.fromDate,
        //     toDate: filters.toDate,
        // }
        // await loadData(payload);
    };

    const handleSelectedNodes = async (nodes) => {
        try {

            if (selectedItems?.length == 0) {
                ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: "Please select transmission to update" });
            }

            const selectedNodes = Array.isArray(nodes) ? nodes : [nodes];
            const nodeData = selectedNodes.map(selectedNode => {
                return {
                    _id: selectedNode._id,
                    Name: selectedNode.Name,
                    ExternalReference: selectedNode.ExternalReference,
                    // passing ParentNode so that we can find parent node in backen and we will remvoe this field in node field
                    ParentNode: selectedNode.ParentNode,
                    CSID: selectedNode.CSID
                }
            });

            const payload = {
                _id: selectedItems.map(x => x._id),
                nodes: nodeData
            };

            const res = await API.updateTransmissionNode(payload);

            if (res?.success) {
                const updatedItems = res?.data ?? [];
                setFilterdMediaData(filterdMediaData.map(item => {
                    const updatedItem = updatedItems.find(
                        updated => updated._id === item._id
                    );
                    return updatedItem?._id ? { ...item, ...updatedItem } : item;
                }));
                ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Nodes linked successfully" });
                // applyFilters(searchText, filters);
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res?.message || "Something went wrong" });
            }
        } catch (err) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Error while linking node" });
        } finally {
            setSelectedItems([]);
            setSelectedState({});
            setIsShowAllNodes(false);
            setShowNodePopup(false);
        }
    };

    const mamHyperLinkCell = (props) => {
        const value = utility.getDataInsideObject(props.dataItem, props.field);
        return (
            <td>
                <div style={{ color: 'blue', cursor: 'pointer' }}
                    onClick={() => window.open(`/home/mamAssets?mamID=${value}`, '_blank')}
                >
                    {value}
                </div>
            </td>

        )
    }

    const handlePublish = async (items = [], publishType) => {
        setSelectedItems([]);
        setSelectedState({});
        try {
            let ids = items.map(x => x._id);
            switch (publishType) {
                case PUBLISH_REPORT.VOD_CATALOGUE_DELETE_BY_ID:
                    // all acction should be delete
                    if (items.some(x => x.action != TRANSMISSION_ACTION.Delete)) {
                        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Some of the selected items are not marked for delete. Please remove those items and try again." });
                        return;
                    }
                    setPublishVodCatalogueMessage("Please wait while publishing Deleted VOD Catalogue...");
                    let res = await API.publishVodCatalogue(ids, publishType, true);
                    if (res.success) {
                        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
                    } else {
                        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
                    }
                    refreshTransmissionBrowser();
                    setPublishVodCatalogueMessage("");
                    break;
                case PUBLISH_REPORT.VOD_CATALOGUE_INCREMENTAL_BY_ID:
                    // all action should be create or update
                    if (items.some(x => x.action != TRANSMISSION_ACTION.Create && x.action != TRANSMISSION_ACTION.Update)) {
                        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Some of the selected items are not created or updated. Please remove those items and try again." });
                        return;
                    }
                    // all action should be TX Ready for Non Catchup
                    if (items.filter(x => !x.isCatchUp).some(x => x.Mam?.Status != MAM_STATUS.TXReady)) {
                        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Some of the selected items are not TX Ready. Please remove those items and try again." });
                        return;
                    }
                    // all node should be linked for Catchup Items
                    if (items.filter(x => x.isCatchUp).some(x => x.nodes == null || x.nodes.length == 0)) {
                        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Some of the selected catch up items are not linked to nodes. Please remove those items and try again." });
                        return;
                    }
                    setPublishVodCatalogueMessage("Please wait while publishing Incremental VOD Catalogue...");
                    let response = await API.publishVodCatalogue(ids, publishType, true);
                    if (response.success) {
                        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: response.message });
                    } else {
                        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: response.message });
                    }
                    refreshTransmissionBrowser();
                    setPublishVodCatalogueMessage("");
                    break;
                default:
                    break;
            }


        } catch (err) {
            console.error(err);
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Error while publishing" });
        }
    }

    const menuModel = [
        selectedItems.length > 1 && {
            label: lang.edit_all_button_tooltip,
            icon: 'pi pi-pencil',
            command: () => setShowEditTransmissonForm({ show: true, data: selectedItems })
        },
        selectedItems.length > 1 && {
            label: lang.edit_action_button_tooltip,
            icon: 'pi pi-pen-to-square',
            command: () => setShowEditTransmissonForm({ show: true, data: selectedItems, isActionEdit: true })
        },
        selectedItems.length > 1 && {
            label: lang.update_nodes_button_text,
            icon: 'pi pi-pen-to-square',
            command: () => setShowNodePopup(true)
        },
        selectedItems.length > 1 && {
            label: lang.create_offer_button_tooltip,
            icon: 'pi pi-plus',
            command: () => setShowCreateOfferForm(true)
        },
        selectedItems.length > 1 && {
            label: lang.attach_offers_button_tooltip,
            icon: 'pi pi-tags',
            command: () => setShowAttachOffers(true)
        },
        filterdMediaData.length > 0 && {
            label: lang.export_dublist_label,
            icon: 'pi pi-download',
            command: () => exportTranscodingDublist()
        },
        selectedItems.length > 1 && {
            label: lang.reset_thumbnail_status_label,
            icon: 'pi pi-refresh',
            command: () => resetThumbnailStatus(selectedItems)
        },
        selectedItems.length > 0 && {
            label: "Publish VOD Catalogue",
            icon: 'pi pi-upload',
            items: [
                {
                    label: "Incremental",
                    icon: 'pi pi-upload',
                    command: () => handlePublish(selectedItems, PUBLISH_REPORT.VOD_CATALOGUE_INCREMENTAL_BY_ID)
                },
                {
                    label: "Delete",
                    icon: 'pi pi-upload',
                    command: () => handlePublish(selectedItems, PUBLISH_REPORT.VOD_CATALOGUE_DELETE_BY_ID)
                },
            ]
        },
        {
            label: lang.preference_button_tooltip,
            icon: 'pi pi-cog',
            command: () => setShowPreferences(!showPreferences)
        },
        selectedItems.length > 1 && {
            label: lang.delete_all_button_tooltip,
            icon: 'pi pi-trash',
            command: () => ConfirmDeleteAlert(() => handleDeleteSelectedItems(selectedItems), () => { })
        },
        selectedItems.length === 1 && {
            label: lang.update_node__button_tooltip,
            icon: 'pi pi-plus',
            command: () => setShowNodePopup(true)
        },
        {
            label: lang.export_excel_button_text || 'Export Excel',
            icon: 'pi pi-file-excel',
            command: () => onExportGridData()
        },
    ].filter(Boolean);

    const showMedia = (dataItem) => {
        let value = dataItem?.mediaEpisode?.SID;
        const mediaCategory = dataItem?.mediaEpisode?.MediaCategory ?? {};
        if (mediaCategory.SID === MEDIACATEGORIES.Movie || mediaCategory.SID === MEDIACATEGORIES.Program) {
            value = dataItem?.mediaEpisode?.AssetId;
        }
        if (value && mediaCategory?.Description.length > 0) {
            window.open(`/home/MediaEpisode/${mediaCategory?.Description}/${value}`, '_blank')
        }
    }

    const mediaHyperLinkCell = (props) => {
        const dataItem = props?.dataItem || {};
        const field = props?.field || "";

        const value = utility.getNestedValue(dataItem, field);

        return (
            <td>
                <div
                    style={{ color: 'blue', cursor: 'pointer' }}
                    onClick={() => showMedia(dataItem)}
                >
                    {value}
                </div>
            </td>
        );
    };

    const onNodeFilterChange = (e, fieldName) => {
        setDropdownFilters((prev) => ({
            ...prev,
            [fieldName]: e.filter?.value || ''
        }));
    };

    const getFilteredDropdownData = (data = [], fieldName) => {
        const filterValue = (dropdownFilters[fieldName] || '').toLowerCase();
        if (!filterValue) return data;
        return data.filter((item) => (item?.Name || '').toLowerCase().includes(filterValue));
    };

    const renderMediaList = () => {
        const FullCenter = ({ children }) => (
            <div style={{
                height: 'calc(100vh - 410px)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#999',
                textAlign: 'center',
                padding: '20px',
                ...gridStyle
            }}>
                {children}
            </div>
        );

        const hasSelection = isFromMain || selectedNode?._id;
        return (
            <div style={{ padding: '15px', ...divstyle }}>
                <div style={{ borderBottom: '2px solid #ddd', paddingBottom: '10px', marginBottom: '15px' }}>
                    <div className='d-flex'>
                        <div className='mr-auto d-flex'>
                            <h3 className='mr-1' style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>{lang.transmissions_header} </h3>
                            <p style={{ fontSize: '13px', color: '#666' }}> ({total} {total === 1 ? 'item' : 'items'} found) </p>
                            <p style={{ fontSize: '13px', color: '#666', marginLeft: '5px' }}>{publishVodCatalogueMessage}</p>
                        </div>
                        {selectedNode?.Name && <p style={{ fontSize: '13px', color: '#666' }}>{`${selectedNode.Name} (${selectedNode?.CSID})`}</p>}
                        {showToggle && <div className='mb-1 d-flex ml-2' style={{ border: "1px solid #007bff", borderRadius: "14px", overflow: "hidden", marginLeft: "auto", width: "140px", height: "26px", cursor: "pointer" }} >
                            <div onClick={() => setIsLinear(!isLinear)} style={{ flex: 1, fontSize: "11px", textAlign: "center", lineHeight: "24px", backgroundColor: !isLinear ? "#007bff" : "white", color: !isLinear ? "white" : "#007bff" }} >
                                {lang.non_linear_transmission_label}
                            </div>
                            <div onClick={() => setIsLinear(!isLinear)}
                                style={{ flex: 1, fontSize: "11px", textAlign: "center", lineHeight: "24px", backgroundColor: isLinear ? "#007bff" : "white", color: isLinear ? "white" : "#007bff" }} >
                                {lang.linear_transmission_label}
                            </div>
                        </div>}
                    </div>
                    {!isLinear &&
                        <div style={{ width: "100%" }}>
                            {/* Row 1: Add Button and Settings/Preference */}
                            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", marginBottom: '15px', gap: '5px' }}>
                                {/* <div>
                                    <AddRoundButton onClick={onCreateTransmission} title={lang.create_transmission_button_tooltip} />
                                </div> */}
                                <div>
                                    <RefreshButton onClick={() => refreshTransmissionBrowser(true)} />
                                </div>
                                <div>
                                    <RoundButton icon="ellipsis-v" title={lang.context_menu_label} onClick={(e) => menuRef.current.show(e)} />
                                    <ContextMenu
                                        ref={menuRef}
                                        model={menuModel}
                                    />
                                </div>
                                <div className='d-flex' style={{ marginLeft: "auto", width: "250px" }}>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm shadow-inset-2 pt-0 pb-0"
                                        id="searchInput"
                                        placeholder={lang.search_button_text}
                                        onChange={onSearch}
                                        onFocus={(e) => {
                                            if (props.setOutSideFocus) {
                                                props.setOutSideFocus(true);
                                            }
                                        }}
                                        onBlur={(e) => {
                                            if (props.setOutSideFocus) {
                                                props.setOutSideFocus(false);
                                            }
                                        }}
                                    />
                                    <button id="search" style={{ border: "0px", backgroundColor: "white" }} >
                                        <span className="input-group-text" style={{ padding: "4px 10px", fontSize: "14px" }}>
                                            <i style={{ margin: "4px 0px" }} className="fa fa-search" />
                                        </span>
                                    </button>
                                </div>
                            </div>

                            {/* Row 2: Status, Node, MAM Status, Offer, Search - All in one row on large screens */}
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap" }}>
                                <div className='col-12 col-sm-6 p-2' style={{ minHeight: '75px', display: 'flex', flexDirection: 'column', flex: '1 1 calc(16.66% - 8px)', minWidth: '150px' }}>
                                    <label style={{ marginBottom: '6px', fontWeight: '500' }}>{lang.status_label}</label>
                                    <DropDownList
                                        data={[defaultActiveStatus, ...Object.keys(TRANSMISSION_STATUS).map((key) => ({ "Description": key, "_id": TRANSMISSION_STATUS[key] }))]}
                                        dataItemKey="_id"
                                        textField="Description"
                                        value={filters.activeStatus}
                                        onChange={onChange}
                                        name="activeStatus"
                                    />
                                </div>
                                {(isFromMedia || isFromMain) && <div className='col-12 col-sm-6 p-2' style={{ minHeight: '75px', display: 'flex', flexDirection: 'column', flex: '1 1 calc(16.66% - 8px)', minWidth: '150px' }}>
                                    <label style={{ marginBottom: '6px', fontWeight: '500' }}>{lang.vod_channel_label}</label>
                                    <DropDownList
                                        data={getFilteredDropdownData(nodes, 'node')}
                                        dataItemKey="_id"
                                        textField="Name"
                                        value={filters.node}
                                        onChange={onChange}
                                        name="node"
                                        filterable={true}
                                        onFilterChange={(e) => onNodeFilterChange(e, 'node')}
                                    />
                                </div>}
                                <div className='col-12 col-sm-6 p-2' style={{ minHeight: '75px', display: 'flex', flexDirection: 'column', flex: '1 1 calc(16.66% - 8px)', minWidth: '150px' }}>
                                    <label style={{ marginBottom: '6px', fontWeight: '500' }}>{lang.mam_asset_status_column}</label>
                                    <DropDownList
                                        data={[defaultMamStatus, ...Object.keys(MAM_STATUS).map((key) => ({ "Description": key, "_id": MAM_STATUS[key] }))]}
                                        dataItemKey="_id"
                                        textField="Description"
                                        value={filters.mamStatus}
                                        onChange={onChange}
                                        name="mamStatus"
                                    />
                                </div>
                                <div className='col-12 col-sm-6 p-2' style={{ minHeight: '75px', display: 'flex', flexDirection: 'column', flex: '1 1 calc(12% - 8px)', minWidth: '150px' }}>
                                    <label style={{ marginBottom: '6px', fontWeight: '500' }}>{lang.from_date_label}</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        name="fromDate"
                                        value={filters.fromDate}
                                        onChange={onDateFilterChange}
                                    />
                                </div>
                                <div className='col-12 col-sm-6 p-2' style={{ minHeight: '75px', display: 'flex', flexDirection: 'column', flex: '1 1 calc(12% - 16px)', minWidth: '150px' }}>
                                    <label style={{ marginBottom: '6px', fontWeight: '500' }}>{lang.to_date_label}</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        name="toDate"
                                        value={filters.toDate}
                                        onChange={onDateFilterChange}
                                        min={filters.fromDate || undefined}
                                    />
                                </div>
                                {/* checkbox not linked and catchup */}
                                {(isFromMedia || isFromMain) && <div className='col-12 col-sm-6 p-2' style={{ minHeight: '75px', display: 'flex', flexDirection: 'column', flex: '1 1 15%', minWidth: '200px' }}>
                                    <label style={{ marginBottom: '10px', fontWeight: '500' }}>&nbsp;</label>
                                    <div style={{ display: 'flex', flexDirection: 'row', gap: '15px', marginLeft: '10px', whiteSpace: 'nowrap' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <input
                                                type="checkbox"
                                                name="notLinked"
                                                checked={filters.notLinked}
                                                onChange={onChange}
                                                style={{ marginTop: '0px' }}
                                            />
                                            <label style={{ marginBottom: '0px', fontWeight: '500' }}>{lang.not_linked_label}</label>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <input
                                                type="checkbox"
                                                name="isCatchup"
                                                checked={filters.isCatchup}
                                                onChange={onChange}
                                                style={{ marginTop: '0px' }}
                                            />
                                            <label style={{ marginBottom: '0px', fontWeight: '500' }}>{lang.catchup_label}</label>
                                        </div>
                                    </div>
                                </div>}
                                {/* apply filter button */}
                                <div className='col-12 col-sm-6 mr-0 pr-0' style={{ height: '65px', display: 'flex', flexDirection: 'column', flex: '1 1 0%', }}>
                                    <label style={{ marginBottom: '10px', fontWeight: '500' }}>&nbsp;</label>
                                    <SaveButton title={lang.apply_filter_button} onClick={() => applyFilters(searchText, filters, true)} />
                                </div>
                            </div>
                        </div>}
                </div>

                {isLinear ? <div className='row'  ><MediaEpisodeHistory gridStyle={{ height: 'calc(100vh - 540px)' }} selectedData={selectedNode} isPopup={false} /> </div>
                    : <div className="media-list" style={{ display: 'grid' }}>

                        {/* LOADING */}
                        {isLoading && (
                            <FullCenter>
                                <Loader />
                            </FullCenter>
                        )}

                        {/* NOTHING SELECTED */}
                        {!isLoading && !hasSelection && (
                            <FullCenter>
                                <i className="fa fa-info-circle" style={{ fontSize: '30px', marginBottom: '8px' }}></i>
                                <p>{lang.select_a_category_from_the_tree_to_view_media_message}</p>
                            </FullCenter>
                        )}

                        {/* NO MEDIA FOUND */}
                        {!isLoading && hasSelection && filterdMediaData.length === 0 && (
                            <FullCenter>
                                <i className="fa fa-folder-open" style={{ fontSize: '60px', marginBottom: '8px' }}></i>
                                <p>{lang.no_media_found_for_this_category_message}</p>
                                <small>{lang.try_selecting_another_category_message}</small>
                            </FullCenter>
                        )}

                        {/* GRID VIEW */}
                        {!isLoading && hasSelection && filterdMediaData.length > 0 && (
                            <Grid
                                style={{ height: 'calc(100vh - 300px)', overflow: 'auto', ...gridStyle }}
                                resizable={true}
                                sortable={{
                                    allowUnsort: true,
                                    mode: 'multiple'
                                }}
                                sort={sort}
                                onSortChange={(e) => {
                                    setSort(e.sort);
                                }}
                                data={process(
                                    filterdMediaData.map(data => ({
                                        ...data,
                                        [SELECTED_FIELD]: !!selectedState[idGetter(data)]
                                    })),
                                    { sort }
                                )}
                                selectedField={SELECTED_FIELD}
                                selectable={{
                                    enabled: true,
                                    mode: 'multiple',
                                    type: 'cell',
                                    checkboxOnly: true,
                                    selectAllHeader: true  // Explicit header support
                                }}
                                onSelectionChange={onSelectionChange}
                                onHeaderSelectionChange={onHeaderSelectionChange}
                                dataItemKey={DATA_ITEM_KEY}
                                pageable={true}
                                skip={page.skip}
                                take={page.take}
                                onPageChange={pageChange}
                                total={total}
                            >
                                <GridColumn cell={MyCommandCell} width={"60px"} locked={true} resizable={false} />
                                <GridColumn field={SELECTED_FIELD} width="50px" />
                                {dataColumns.map((column, index) => {
                                    if (column.type === COLUMNSTYPE.date) {
                                        return (
                                            <GridColumn
                                                key={index}
                                                field={column.name}
                                                cell={DateOnlyCell}
                                                title={column.label}
                                                width={column.width ?? 200}
                                                sortable={true}
                                            />
                                        );
                                    } else if (column.type === COLUMNSTYPE.datetime) {
                                        return (
                                            <GridColumn
                                                key={index}
                                                field={column.name}
                                                cell={DateCell}
                                                title={column.label}
                                                width={column.width ?? 200}
                                                sortable={true}
                                            />
                                        );
                                    } else if (column.name.includes("Duration") || column.type == COLUMNSTYPE.time) {
                                        return (
                                            <GridColumn
                                                key={index}
                                                field={column.name}
                                                cell={TimeCell}
                                                title={column.label}
                                                width={column.width ?? 200}
                                                sortable={true}
                                            />
                                        );
                                    } else if (column.name === "SID") {
                                        return;
                                    }
                                    else if (column.type === COLUMNSTYPE.array) {
                                        return (
                                            <GridColumn
                                                key={index}
                                                field={column.name}
                                                cell={ArrayCell}
                                                title={column.label}
                                                width={column.width ?? 200}
                                                format={column.format ?? "Description"}
                                                sortable={false}
                                            />
                                        );
                                    }
                                    else if (column.type === COLUMNSTYPE.transmissionTypeStatus) {
                                        return (
                                            <GridColumn
                                                key={index}
                                                field={column.name}
                                                cell={TransmissionTypeStatusCell}
                                                title={column.label}
                                                width={column.width ?? 200}
                                                sortable={false}
                                            />
                                        );
                                    }
                                    else if (column.label === "Title") {
                                        return (
                                            <GridColumn
                                                key={index}
                                                field={column.name}
                                                cell={mediaHyperLinkCell}
                                                title={column.label}
                                                width={column.width ?? 200}
                                                format={column.format}
                                                sortable={false}
                                            />
                                        );
                                    }
                                    else if (column.type === COLUMNSTYPE.mamStatus) {
                                        return (
                                            <GridColumn
                                                key={index}
                                                field={column.name}
                                                cell={MAMStatusCell}
                                                title={column.label}
                                                width={column.width ?? 200}
                                                sortable={false}
                                            />
                                        );
                                    }
                                    else if (column.type === COLUMNSTYPE.localdatetime) {
                                        return (
                                            <GridColumn
                                                key={index}
                                                field={column.name}
                                                cell={LocalDateTimeColumn}
                                                title={column.label}
                                                width={column.width ?? 200}
                                                sortable={false}
                                            />
                                        );
                                    }
                                    else if (column.type === COLUMNSTYPE.offerCount) {
                                        return (
                                            <GridColumn
                                                field={column.name}
                                                title={column.label}
                                                cell={showOffersCell}
                                                width={column.width ?? 200}
                                                sortable={false}
                                            />
                                        )
                                    }
                                    else if (column.label === "MAM ID") {
                                        return (
                                            <GridColumn
                                                field={column.name}
                                                title={column.label}
                                                cell={mamHyperLinkCell}
                                                width={column.width ?? 120}
                                                sortable={false}
                                            />
                                        )
                                    }
                                    else if (column.name === "status") {
                                        return (
                                            <GridColumn
                                                field={column.name}
                                                title={column.label}
                                                cell={transmissionStatusCell}
                                                width={column.width ?? 120}
                                                sortable={false}
                                            />
                                        )
                                    }
                                    else if (column.name === "action") {
                                        return (
                                            <GridColumn
                                                field={column.name}
                                                title={column.label}
                                                cell={actionStatusCell}
                                                width={column.width ?? 120}
                                                sortable={false}
                                            />
                                        )
                                    }
                                    else if (column.name === "IsThumbnailProcessed") {
                                        return (
                                            <GridColumn
                                                field={column.name}
                                                title={column.label}
                                                cell={thumbnailStatusCell}
                                                width={column.width ?? 130}
                                                sortable={false}
                                            />
                                        )
                                    }
                                    else {
                                        return (
                                            column.type !== COLUMNSTYPE.hidden && (
                                                <GridColumn
                                                    key={index}
                                                    field={column.name}
                                                    title={column.label}
                                                    width={column.width ?? 200}
                                                    sortable={true}
                                                />
                                            )
                                        );
                                    }
                                })}

                            </Grid>
                        )}

                    </div>}
            </div>
        );
    };

    const handleTransmissionUpdates = (updatedIds, saveData) => {
        setSelectedState({});
        setSelectedItems([]);
        setMediaData(mediaData.map(x => updatedIds.includes(x._id) ? { ...x, ...saveData } : x));
        setFilterdMediaData(filterdMediaData.map(x => updatedIds.includes(x._id) ? { ...x, ...saveData } : x));
        !showEditTransmissonForm.isActionEdit && refreshTransmissionBrowser(false, true);
    }

    return (
        <div className="row" style={{ width: '100%' }}>
            <div className={showMetaDataForm.show ? 'col-7' : 'col-12'}>
                <div style={{
                    border: '1px solid #ddd',
                    backgroundColor: '#fff',
                    borderRadius: '4px',
                    height: 'calc(100vh - 150px)',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#888 #f1f1f1',
                    ...mainStyle
                }}>
                    <style>
                        {`
                                .col-8 > div::-webkit-scrollbar {
                                    width: 8px;
                                }
                                .col-8 > div::-webkit-scrollbar-track {
                                    background: #f1f1f1;
                                    border-radius: 4px;
                                }
                                .col-8 > div::-webkit-scrollbar-thumb {
                                    background: #888;
                                    border-radius: 4px;
                                }
                                .col-8 > div::-webkit-scrollbar-thumb:hover {
                                    background: #555;
                                }
                            `}
                    </style>
                    {renderMediaList()}

                </div>
            </div>
            {showMetaDataForm.show && <div className='col'>
                <ManageNodeTreeViewEditPanel mainStyle={{ top: 0, height: "100%", width: "100%" }} mediaEpisode={showMetaDataForm?.item?.mediaEpisode} selectedItem={showMetaDataForm.item} transcodeStatus={showMetaDataForm.item?.latestTranscodeStatus?.Description ?? 'N/A'} setGridData={(data) => handleSingleSelectUpdatedData(data?.length > 0 ? data[0] : {})} setSelectedItem={() => setShowMetaDataForm({ show: false, item: {} })} />
            </div>}

            {showPreferences && <UserPreference entityName={ENTITYNAME.Transmissions} preferenceColumnENntityName={ENTITYNAME.Transmissions} handleClose={onCloseUserPrefence} />}
            {showMediaSelectionOfferCollection && <ContractCollectionSelection addButtonTitle="Select" title={lang.media_library_dialog_header} wherestatement={['MediaCategory.isLong', '=', true]} setDataList={handleOfferMedia} entityname={ENTITYNAME.MediaEpisode} closeForm={() => setShowMediaSelectionOfferCollection(false)} width={"50vw"} />}
            {showTransmissonForm && <CreateTransmissionForm isFromTransmission={true} onSubmit={updateOfferGridData} onClose={onCloseCreateTransmissionForm} width={"25vw"} />}
            {showOffersForm.show && <BossDialog title={showOffersForm.item?.mediaEpisode?.Title} onClose={() => setShowOffersForm({ show: false, item: {} })} width={"65vw"}>
                <AssetOfferLinkBrowserCollection
                    selectedMediaData={[showOffersForm.item?.mediaEpisode]}
                    gridstyle={{ height: 'calc(100vh - 400px)' }}
                    title={lang.offers_dialog_header}
                    entityname={ENTITYNAME.AssetOfferLink}
                    wherestatement={['transmission._id', '=', showOffersForm.item?._id]}
                    showEdit={false}
                    showAdd={false}
                    isFromTransmission={true}
                    refreshTransmission={refreshTransmissionBrowser}
                    transmissionsData={[showOffersForm.item]}
                />
            </BossDialog>}
            {showAttachOffers && <CollectionSelection setDataList={handleAttachOffers} closeForm={() => setShowAttachOffers(false)} title={lang.add_offers_dialog_header} entityname={ENTITYNAME.OFFER} width={"50vw"} wherestatement={['EndDateTime', '>', utility.getCurrentDate()]} />}
            {showEditTransmissonForm.show && <EditTransmissonForm isActionEdit={showEditTransmissonForm.isActionEdit} data={showEditTransmissonForm.data} onClose={() => setShowEditTransmissonForm({ show: false, data: [] })} setDataList={handleTransmissionUpdates} />}
            {showNodePopup && <BossDialog title={lang.select_nodes_dialog_header} width='600px' onClose={() => setShowNodePopup(false)}>
                <div
                    className="d-flex justify-content-end align-items-center mb-3"
                    style={{
                        padding: "8px 12px",
                        background: "#f8f9fa",
                        borderRadius: "8px",
                        border: "1px solid #e9ecef"
                    }}
                >
                    <label
                        htmlFor="isShowAllNodes"
                        className="d-flex align-items-center gap-2 m-0"
                        style={{
                            cursor: "pointer",
                            fontWeight: 500,
                            color: "#495057"
                        }}
                    >
                        <input
                            id="isShowAllNodes"
                            type="checkbox"
                            name="isShowAllNodes"
                            checked={isShowAllNodes}
                            value={isShowAllNodes}
                            onChange={(e) => setIsShowAllNodes(e.target.checked)}
                            style={{
                                width: "16px",
                                height: "16px",
                                cursor: "pointer"
                            }}
                        />

                        <span className='ml-1'>{lang.show_all_nodes_label}</span>
                    </label>
                </div>
                <NodeTreeViewForm isSaveButton={true} isShowAllNodes={isShowAllNodes} isMultiSelect={true} onClose={() => setShowNodePopup(false)} showCatalogue={false} isFromMedia={true} handleSelectedNodes={handleSelectedNodes} selectedNodeIds={isShowAllNodes ? [] : selectedItems.map(i => i?.parentNode?._id ?? null)} />
            </BossDialog>}
            {showCreateOfferForm && <CreateTransmissionOfferForm transmissionIds={selectedItems?.length > 0 ? selectedItems.map((x) => x._id) : []} isFromTransmission={true} cancelEdit={() => setShowCreateOfferForm(false)} />}
        </div>
    )
}